import { useContext, useState } from "react";
import styles from "./caseDossier.module.scss";
import Button from "components/Button";
import { ICaseSimple } from "dto/Cases/ICaseSimple";
import CaseDossier from "components/CaseDossier";
import casesService from "api/casesService";
import { IDossierItem } from "dto/Dossier/IDossierItem";
import KeysContext from "contexts/KeysContext";
import { getBlob } from "utils/getBlob";
import { getFile } from "utils/getFile";
import { decryptFile } from "utils/decryptFile";
import { getUserId } from "utils/getUserId";
import { useAuth } from "react-oidc-context";
import { IUploadedFile } from "./typings";
import CloseIcon from "assets/icons/close.svg?react";
import SearchCasesNew from "components/SearchCasesNew";
import { useDossierStore } from "store/dossier.store";
import { replaceFileExtension } from "utils/replaceFileExtension";
import { useTranslation } from "react-i18next";

export const CaseDossierWrapper = ({
  c,
  handleAddFiles,
  toggle,
}: {
  c?: ICaseSimple;
  handleAddFiles: (files: IUploadedFile[]) => void;
  toggle: () => void;
}) => {
  const { t } = useTranslation();
  const auth = useAuth();
  const userId = getUserId(auth.user!);

  const [cc, setCase] = useState<ICaseSimple | null>(c);
  const { data: Case } = casesService.useGetCase(cc?.Id ?? undefined);

  const [isLoading, setIsLoading] = useState(false);

  const { keys } = useContext(KeysContext);

  const { selectedItems } = useDossierStore();

  const handleAdd = async (selected?: IDossierItem[]) => {
    setIsLoading(true);
    const files = [];
    // todo: ?? selectedItems
    for (const element of selected ?? selectedItems) {
      const file = await getFile(element.SignedPdfUri ?? element.FileUri ?? "");
      const blob = await getBlob(file.data.Url);
      const key = keys.find((key: any) => key?.Id === element.EncryptionKeyId);

      if (!key) return;

      let parentKey = null;
      //@ts-ignore
      if (key.ParentKeyId) {
        parentKey = keys.find(
          //@ts-ignore
          (pkey: any) => pkey?.Id === key?.ParentKeyId,
        );
      }
      const decryptedFile = await decryptFile(
        userId ?? "",
        new Blob([blob.data]),
        key,
        parentKey,
      );

      let fileName = element.FileName ?? "";

      if (element.SignedPdfUri) {
        if (!fileName.toLowerCase().endsWith(".pdf")) {
          fileName = replaceFileExtension(fileName, ".pdf");
        }
      }

      const el = {
        file: decryptedFile,
        name: fileName,
        fileType: element.FileContentType ?? "application/other",
        size: decryptedFile.size,
      };
      files.push(el);
    }

    handleAddFiles(files);
    setIsLoading(false);
    toggle();
  };

  return (
    <div className={styles.modal}>
      <div className={styles.wrapper}>
        <div className={styles.titleWrapper}>
          <div className={styles.title}>Dodaj załącznik</div>
          <CloseIcon onClick={toggle} />
        </div>
        <div className={styles.content}>
          {!c && (
            <SearchCasesNew
              setAddNewEntity={() => {}}
              onChoose={(a) => setCase(a)}
              settedCase={cc}
              disableSettingActiveCase={true}
            />
          )}
          <div className={styles.dossier}>
            <CaseDossier
              isOutcoming
              handleAdd={handleAdd}
              className={styles.dossier}
              Case={Case ?? null}
              allInOne={!Case}
              hideCreate={true}
            />
          </div>
          <div className={styles.buttons}>
            <Button
              text={t("documents.addFiles")}
              disabled={isLoading}
              loading={isLoading}
              onClick={handleAdd}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
